import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from '@/components/ui/toast'
import { useToast } from '@/hooks/use-toast'
import { CommonCancelCircle } from '@/icons'
import { shortString } from '@/utils'

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} variant={variant} className='py-3' {...props}>
            <div className='flex gap-4'>
              {variant === 'destructive' && (
                <div className='text-white-100'>
                  <CommonCancelCircle className='size-6' />
                </div>
              )}
              <div className='grid gap-1'>
                {title && <ToastTitle className='first-letter:uppercase'>{title}</ToastTitle>}
                {description && (
                  <ToastDescription className='first-letter:uppercase break-words'>
                    {typeof description === 'string' ? shortString(description, 400) : description}
                  </ToastDescription>
                )}
              </div>
              {action}
            </div>
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
